import { IntlProvider } from 'react-intl';
import { BrowserRouter, Route, Routes } from 'react-router';
import NonLoggedInAppBanner from 'src/components/AppBanner/NonLoggedInAppBanner';
import AsioNeonResponsiveThemeProvider from '../theme/AsioNeonResponsiveThemeProvider';
import Home from './pages/Home';

const App = () => {
    return (
        <BrowserRouter
            future={{
                v7_relativeSplatPath: true,
            }}>
            <IntlProvider locale="en">
                <AsioNeonResponsiveThemeProvider>
                    <NonLoggedInAppBanner />
                    <Routes>
                        <Route path="*" element={<Home />} />
                    </Routes>
                </AsioNeonResponsiveThemeProvider>
            </IntlProvider>
        </BrowserRouter>
    );
};

export default App;
